export enum TaskStatus {
  NotDefined = "not_defined",
  Published = "published",
  Drafted = "drafted",
  Archived = "archived",
}
